<script>
    // import { browser } from '$app/environment';
    import { page } from '$app/stores';
    import { fade, fly } from 'svelte/transition';

    import Auth from './Auth.svelte';
    // import Button from './Button.svelte';
    import Icon from './Icon.svelte';

    import Logo from './Logo.svelte';

    import Button from './Button.svelte';
    import FeedbackButton from './FeedbackButton.svelte';
    import FeedbackModal from './FeedbackModal.svelte';
    import AuthLinks from './AuthLinks.svelte';

    $: nav_items = $page.data.nav_items || [];

    const handle_logged = () => {
        let params = new URLSearchParams(location.search);

        if (params.get('redirectTo')) {
            location.href = params.get('redirectTo');
        } else {
            location.reload();
        }
    };

    let path = $page.url.pathname;
    let sidebar_open = false;

    const open_sidebar = () => {
        sidebar_open = true;
        document.body.classList.add('sidebar-open');
    };

    const close_sidebar = () => {
        sidebar_open = false;
        document.body.classList.remove('sidebar-open');
    };

    let show_feedback_modal = false;
</script>

<div
    class="w-full lg:fixed lg:inset-x-0 lg:top-0 lg:z-30 lg:flex lg:justify-center lg:bg-black/70 lg:backdrop-blur-md lg:transform-gpu"
>
    <header
        class="container mx-auto w-full flex justify-between flex-wrap items-center px-4 sm:px-8 py-4 md:flex-nowrap gap-4 lg:gap-8"
    >
        <div class="flex items-center gap-6 lg:gap-8 min-w-0">
            <a href="/" class="flex-shrink-0 -ml-1">
                <Logo class="w-32" />
            </a>

            <!-- Desktop Navigation -->
            <nav class="hidden lg:flex gap-1 items-center min-w-0">
                {#each nav_items as item (item)}
                    <a
                        href={item.path}
                        class="px-2 py-2 rounded-full-squircle whitespace-nowrap {path ===
                        item.path
                            ? 'bg-surface-highlight'
                            : path.startsWith(item.path)
                            ? 'bg-surface-highlight link'
                            : 'link'}"
                    >
                        {item.title}
                    </a>
                {/each}
            </nav>
        </div>

        <!-- Mobile Navigation -->
        <div class="lg:hidden">
            <Button on:click={open_sidebar} right>
                <Icon icon="menu" lg />
            </Button>
        </div>

        {#if sidebar_open}
            <!-- Overlay backdrop -->
            <div
                class="fixed inset-0 bg-black/70 z-40"
                in:fade={{ duration: 200 }}
                out:fade={{ duration: 200 }}
                on:click={close_sidebar}
                on:keydown={(e) => e.key === 'Escape' && close_sidebar()}
                role="button"
                tabindex="0"
            />

            <!-- Sliding sidebar -->
            <nav
                class="fixed flex flex-col right-0 top-0 h-full w-80 max-w-[80vw] bg-gradient z-50 shadow-xl border-l border-neutral-900"
                in:fly={{ x: 320, duration: 300 }}
                out:fly={{ x: 320, duration: 300 }}
            >
                <!-- Close button -->
                <div
                    class="h-24 xs:h-28 ml-auto py-4 flex items-center justify-end"
                >
                    <Button on:click={close_sidebar}>
                        <Icon icon="times" lg />
                    </Button>
                </div>

                <!-- Navigation items -->
                <div class="px-4 space-y-1 flex-1 overflow-y-auto">
                    {#each nav_items as item (item)}
                        <a
                            href={item.path}
                            class="block px-4 py-2 rounded-lg {path ===
                            item.path
                                ? 'bg-surface-highlight'
                                : path.startsWith(item.path)
                                ? 'bg-surface-highlight link'
                                : 'link hover:bg-surface-highlight'}"
                            on:click={close_sidebar}
                        >
                            {item.title}
                        </a>
                    {/each}

                    <AuthLinks />
                </div>

                <!-- Auth component -->
                <div class=" p-4 border-t border-border-muted space-y-4">
                    <Button
                        outline
                        lg
                        block
                        on:click={() => (show_feedback_modal = true)}
                        >Feedback</Button
                    >

                    <Auth
                        on:loged={handle_logged}
                        button_props={{
                            pill: true,
                            class: 'w-full'
                        }}
                    />
                </div>
            </nav>
        {/if}

        <!-- Desktop Auth -->
        <div class="hidden lg:block">
            <Auth
                on:loged={handle_logged}
                button_props={{
                    pill: true,
                    class: 'md:border-t-0 whitespace-nowrap'
                }}
                use_popover
            />
        </div>
    </header>
</div>

<div class="header-spacer hidden lg:block" aria-hidden="true" />

<FeedbackButton
    on:openFeedback={() => (show_feedback_modal = true)}
    class="max-sm:hidden"
/>

<FeedbackModal
    bind:shown={show_feedback_modal}
    on:close={() => (show_feedback_modal = false)}
/>

<style>
    :global(body.sidebar-open) {
        overflow: hidden;
    }

    .bg-gradient {
        background-image: linear-gradient(to bottom, #000, var(--surface-main));
        background-size: 100% 500%;
        background-repeat: no-repeat;
        background-color: var(--surface-main);
    }

    .header-spacer {
        height: var(--desktop-header-offset, 6rem);
    }
</style>
